import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { GaugeModule } from 'angular-gauge';

import { CategoryItemComponent, CoinsBadgeComponent, DiscountLevelBadgeComponent, FavsProgressBarComponent, FilterPillComponent, GetmButtonComponent, LeftLabelCardComponent, LevelStepBadgeComponent, MenuButtonComponent, PriceDisplayComponent, PromoTagSaleComponent, QuantitySelectorComponent, SubcategoryItemComponent, TagCardImgComponent, TagCardProductComponent } from '../components-v2/atoms';
import { AddAnotherPromoRowComponent, BlockHeaderComponent, BodyDetailProductComponent, BottomHelperCardComponent, CartGeneralItemComponent, CartPromoItemComponent, CategoriesAndSubcategoriesComponent, DeadlineStatusComponent, EcoVirtualListComponent, FavsControlComponent, FloatingCartComponent, GetmOrderSummaryComponent, LevelsStepperBarComponent, ProductCardV2Component, PromoBottomBarComponent, PromoCardV2Component, PromoProductRowComponent, PurchaseLimitsBarComponent, SearchComponentComponent, SearchNoResultsComponent, SearchResultItemComponent, SpecialInfoComponent, SwipeActionsComponent, TopImageDetailComponent } from '../components-v2/molecules';
import { ButtonGetmComponent } from '../components/button-getm/button-getm.component';
import { CardGetmComponent } from '../components/card-getm/card-getm.component';
import { CardHeaderGetmComponent } from '../components/card-header-getm/card-header-getm.component';
import { DisabledUserComponent } from '../components/disabled-user/disabled-user.component';
import { DropdownAutocompleteComponent } from '../components/dropdown-autocomplete/dropdown-autocomplete.component';
import { EmptyDataComponent } from '../components/empty-data/empty-data.component';
import { FirstOverlaysComponent } from '../components/first-overlays/first-overlays.component';
import { FirstTimeComponent } from '../components/first-time/first-time.component';
import { HelpDeliveryComponent } from '../components/help-delivery-popover/help-delivery-popover.component';
import { IconGetmComponent } from '../components/icon-getm/icon-getm.component';
import { ListMorePopoverComponent } from '../components/list-more-popover/list-more-popover.component';
import { PasswordFormatComponent } from '../components/password-format/password-format.component';
import { ProductCardComponent } from '../components/product-card/product-card.component';
import { ProfileBannerComponent } from '../components/profile-banner/profile-banner.component';
import { PromoPresentComponent } from '../components/promo-present/promo-present.component';
import { PromotionsCardComponent } from '../components/promotions-card/promotions-card.component';
import { RangeInputComponent } from '../components/range-input/range-input.component';
import { SelectFieldGetmComponent } from '../components/select-field-getm/select-field-getm.component';
import { SexSelectorComponent } from '../components/sex-selector/sex-selector.component';
import { TabsGetmComponent } from '../components/tabs-getm/tabs-getm.component';
import { TranslateFormatterDirective } from '../directives/translate-formatter/translate-formatter.directive';
import { AssetsUrlPipe } from '../pipes/assets-url/assets-url.pipe';
import { CheckIconPipe } from '../pipes/check-icon/check-icon.pipe';
import { FilterArrayPipe } from '../pipes/filter-array/filter-array.pipe';
import { FiltroPipe } from '../pipes/filtro.pipe';
import { HighlightUnitsPipe } from '../pipes/highlight-units/highlight-units.pipe';
import { HtmlSeguroPipe } from '../pipes/html-seguro.pipe';
import { IsNullEmptyPipe } from '../pipes/is-null-empty/is-null-empty.pipe';
import { RemainingTimePipe } from '../pipes/remaining-time/remaining-time.pipe';
import { StatusRcppPipe } from '../pipes/status-rcpp/status-rcpp.pipe';
import { SumTotalPipe } from '../pipes/sum-total/sum-total.pipe';
import { SummaryPricePipe } from '../pipes/summary-price/summary-price.pipe';
import { TypePromoColorPipe } from '../pipes/type-promo-color/type-promo-color.pipe';
import { VideoPipe } from '../pipes/video/video.pipe';
import {
  PasswordsValidatorComponent
} from './../../private/shared/components/passwords-validator/passwords-validator.component';
import { CheckboxGetmComponent } from './../components/checkbox-getm/checkbox-getm.component';
import { EcoMeasureDirective } from './../directives/eco-measure/eco-measure.directive';
import { LimitRangeDirective } from './../directives/limit-range.directive';

const ATOMS = [
  CategoryItemComponent,
  CoinsBadgeComponent,
  GetmButtonComponent,
  LeftLabelCardComponent,
  LevelStepBadgeComponent,
  MenuButtonComponent,
  PriceDisplayComponent,
  PromoTagSaleComponent,
  TagCardProductComponent,
  FilterPillComponent,
  TagCardImgComponent,
  DiscountLevelBadgeComponent,
  QuantitySelectorComponent,
  SubcategoryItemComponent,
  FavsProgressBarComponent,
];

const MOLECULES = [
  BodyDetailProductComponent,
  BottomHelperCardComponent,
  SearchResultItemComponent,
  PromoProductRowComponent,
  ProductCardV2Component,
  PromoCardV2Component,
  SearchComponentComponent,
  SearchNoResultsComponent,
  AddAnotherPromoRowComponent,
  BlockHeaderComponent,
  CartGeneralItemComponent,
  CartPromoItemComponent,
  DeadlineStatusComponent,
  SpecialInfoComponent,
  PurchaseLimitsBarComponent,
  FloatingCartComponent,
  LevelsStepperBarComponent,
  SwipeActionsComponent,
  PromoBottomBarComponent,
  CategoriesAndSubcategoriesComponent,
  GetmOrderSummaryComponent,
  EcoVirtualListComponent,
  FavsControlComponent,
  TopImageDetailComponent,
];

const COMPONENTS = [
  EmptyDataComponent
  , SexSelectorComponent
  , PasswordFormatComponent
  , HtmlSeguroPipe
  , AssetsUrlPipe
  , CheckIconPipe
  , VideoPipe
  , FiltroPipe
  , TypePromoColorPipe
  , SumTotalPipe
  , StatusRcppPipe
  , RemainingTimePipe
  , HighlightUnitsPipe
  , IsNullEmptyPipe
  , FilterArrayPipe
  , FirstTimeComponent
  , FirstOverlaysComponent
  , DropdownAutocompleteComponent
  , ProfileBannerComponent
  , DisabledUserComponent
  , ListMorePopoverComponent
  , ProductCardComponent
  , RangeInputComponent
  , HelpDeliveryComponent
  , PromotionsCardComponent
  , PromoPresentComponent
  , PasswordsValidatorComponent
  , IconGetmComponent
  , ButtonGetmComponent
  , CheckboxGetmComponent
  , TabsGetmComponent
  , CardGetmComponent
  , CardHeaderGetmComponent
  , SelectFieldGetmComponent
  , LimitRangeDirective
  , EcoMeasureDirective
  , TranslateFormatterDirective
  , SummaryPricePipe
]

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...ATOMS,
    ...MOLECULES,
  ],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    GaugeModule.forRoot(),
  ],
  exports: [
    ...COMPONENTS,
    ...ATOMS,
    ...MOLECULES,
    TranslateModule
  ]
})
export class ModuleSharedModule { }
